import { showLoading, hideLoading } from 'react-redux-loading-bar';
import get from 'lodash/get';
import HttpV2 from '../../../httpv2';
import * as types from './constants';

const ITEMS_PER_PAGE = 50;

const fetchItems = (url, skip = 0) => dispatch =>
  HttpV2.get(url, { limit: ITEMS_PER_PAGE, skip })
    .then((response) => {
      const items = get(response, 'rows', []);
      dispatch({
        type: types.FETCH_ITEMS,
        payload: items,
      });
      return items.length === ITEMS_PER_PAGE ? dispatch(fetchItems(url, skip + ITEMS_PER_PAGE)) : Promise.resolve();
    });

export const fetchAllItems = brandId => async (dispatch) => {
  dispatch({ type: types.CLEAR_ITEMS });
  dispatch(showLoading());
  await dispatch(fetchItems(`/brand/${brandId}/service-category`, 0));
  dispatch(hideLoading());
};

export const fetchItem = (brandId, id) => dispatch =>
  HttpV2.get(`/brand/${brandId}/service-category/${id}`)
    .then(response =>
      dispatch({
        type: types.FETCH_ITEM,
        payload: response,
      })
    );

export const addItem = (brandId, data) => dispatch =>
  HttpV2.post(`/brand/${brandId}/service-category`, data)
    .then(response =>
      dispatch({
        type: types.ADD_ITEM,
        payload: response,
      })
    );

export const updateItem = (brandId, id, data) => dispatch =>
  HttpV2.put(`/brand/${brandId}/service-category/${id}`, data)
    .then(response =>
      dispatch({
        type: types.UPDATE_ITEM,
        payload: response,
      })
    );

export const deleteItem = (brandId, id) => dispatch =>
  HttpV2.delete(`/brand/${brandId}/service-category/${id}`)
    .then(() =>
      dispatch({
        type: types.DELETE_ITEM,
        payload: id,
      })
    );
